import { FC } from 'react'

import styled from 'styled-components'

import APIendpoint, { isCustomEndpoint } from 'core/actions/helpers/APIendpoint'
import { variables } from 'core/styles'

import PeachOverrides from './PeachOverrides'
import { overridesEnabled } from './storage'

const env = isCustomEndpoint ? 'unknown' : import.meta.env.VITE_ENV_LABEL ?? 'unknown'

const Badge: FC = () =>
  import.meta.env.VITE_ENV_LABEL_HIDE === 'true' ?
    null
  : <PeachOverrides>
      <StyledBadgeButton
        title={`API Base: ${APIendpoint}`}
        disabled={!overridesEnabled}
        $backgroundColor={
          env === 'local' ? variables.colorGreenLighten
          : env === 'dev' ?
            variables.colorBlueLighten
          : env === 'sandbox' ?
            variables.colorOrangeLighten
          : variables.colorRedLighten
        }
        $color={
          env === 'local' ? variables.colorGreen
          : env === 'dev' ?
            variables.colorBluePrimary
          : env === 'sandbox' ?
            variables.colorOrange
          : variables.colorRed
        }
      >
        {env}
      </StyledBadgeButton>
    </PeachOverrides>

export default Badge

const StyledBadgeButton = styled.button<{ $color: string; $backgroundColor: string }>`
  position: fixed;
  right: 6px;
  bottom: 6px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1;
  color: ${(p) => p.$color};
  white-space: nowrap;
  cursor: pointer;
  background-color: ${(p) => p.$backgroundColor};
  border: 1px solid ${(p) => p.$color};
  border-radius: 3px;
  opacity: 0.8;

  &:disabled {
    cursor: default;
  }
`
